<template>
  <b-row class="notifications-event-type-recipients">
    <b-col md="12">
      <section class="notifications-event-type-recipients__field">
        <div class="notifications-event-type-recipients__heading">
          <span><AppIcon name="group" /></span>
          <div><h6>Roles</h6><p>Notifica al staff que tenga asignado alguno de estos roles.</p></div>
        </div>
        <v-select :options="arr.select.roles" v-model="crud.form.roles_notification" placeholder="Seleccionar roles" :multiple="true" :select-on-tab="true" @input="emitChange()"></v-select>
      </section>
    </b-col>
    <b-col md="12">
      <section class="notifications-event-type-recipients__field">
        <div class="notifications-event-type-recipients__heading">
          <span><AppIcon name="person" /></span>
          <div><h6>Staff</h6><p>Agrega destinatarios puntuales, además de los roles seleccionados.</p></div>
        </div>
        <v-select :options="arr.select.staff" v-model="crud.form.staff_notification" placeholder="Seleccionar staff" :multiple="true" :select-on-tab="true" @input="emitChange()"></v-select>
      </section>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from '../services'

  export default {
    props: {
      roles_notification: {
        type: Array,
        default: null,
      },
      staff_notification: {
        type: Array,
        default: null,
      },
    },
    data: () => {
      return {
        crud: {
          form: {
            roles_notification: [],
            staff_notification: [],
          }
        },
        arr: {
          select: {
            roles: [],
            staff: []
          }
        }
      }
    },
    mounted() {
      this.getRoles()
      this.getStaff()

      this._start = true
    },
    activated() {
      if (this._start) {
        this._start = false
        return
      }

      this.getRoles()
      this.getStaff()
    },
    methods: {
      getStaff() {
        serviceAPI.obtenerStaff().then(response => {
          var data = response.data

          data.forEach(element => {
            this.arr.select.staff.push({code: element.id, label: element.name})
          });

          if (this.staff_notification) {
            this.staff_notification.forEach(element => {
              this.crud.form.staff_notification.push({code: element, label: this.getName('staff', element)})
            });
          }
        })
      },
      getRoles() {
        serviceAPI.obtenerRoles().then(response => {
          var data = response.data

          data.forEach(element => {
            this.arr.select.roles.push({code: element.id, label: element.name})
          });

          if (this.roles_notification) {
            this.roles_notification.forEach(element => {
              this.crud.form.roles_notification.push({code: element, label: this.getName('roles', element)})
            });
          }
        })
      },
      emitChange() {
        this.$emit('select-recipients', this.crud.form)
      },
      getName(type, code) {
        var name = ''
        if (type == 'roles') {
          this.arr.select.roles.forEach(element => {
            if (element.code == code) {
              name = element.label
            }
          });
        }
        if (type == 'staff') {
          this.arr.select.staff.forEach(element => {
            if (element.code == code) {
              name = element.label
            }
          });
        }
        return name
      }
    }
  }
</script>
<style scoped>
.notifications-event-type-recipients__field { margin-bottom: 14px; padding: 14px; border: 1px solid var(--app-color-border); border-radius: 10px; }
.notifications-event-type-recipients__heading { display: flex; align-items: flex-start; gap: 9px; margin-bottom: 10px; }
.notifications-event-type-recipients__heading > span { display: inline-flex; align-items: center; justify-content: center; width: 29px; height: 29px; border-radius: 8px; background: var(--app-color-primary-soft); color: var(--app-color-primary); }
.notifications-event-type-recipients__heading h6 { margin: 0; color: var(--app-color-text); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); }
.notifications-event-type-recipients__heading p { margin: 2px 0 0; color: var(--app-color-text-muted); font-size: var(--app-text-xs); }
</style>
